module.exports = __webpack_public_path__ + "media/images/prizes__sidebar--image-e35a4434cc866adf01da269d14dfeff0.png";